module.exports = __webpack_public_path__ + "static/media/DesertOasisShackA0039_design_clean_v003.88fb5820.png";